<template>
    <div class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '地圖'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <mdMap
                    caption=""
                    :geojson="geojson"
                >
                    <div v-if="content.html" v-html="content.html"></div>
                </mdMap>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdMap from '@/components/mdMap'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdMap,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                styleSet: $styleSet,
                geojson: {}
            }
        },
        computed: {
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    }

                let $results = [].concat($moreBtns);

                if( this.haveAction ) {
                    $results.push($action);
                }

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content;

                $content[func]();
            },
            action: function(){
                let $content = this.content,
                    $_action = $content.action;

                if( this.haveAction ) {
                    $_action();
                }

                if( $content.actionStopClose !== true ) {
                    this.close();
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            }
        },
        created: function(){
            if( this.content.data ) { //這有點蠢，等地圖 svg 先建出來，再傳資料給他算寬高
                let $timer = window.setTimeout(() => {
                        this.$set(this, 'geojson', this.content.data);
                        window.clearTimeout($timer);
                    }, 300);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
